import React, { useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useInView } from "framer-motion";
import Lightbox from "yet-another-react-lightbox";
import GalleryInternationalPromotions from "./GalleryInternationalPromotions";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "./InternationalPromotionsMedia.css";
import { BsChevronDoubleRight } from "react-icons/bs";

const INTERNATIONAL = [
  {
    id: "ip-01",
    country: "Egypt",
    code: "EGY",
    flag: "🇪🇬",
    img: "https://images.unsplash.com/photo-1431540015161-0bf868a2d407?q=80&w=900&auto=format&fit=crop",
    images: [
      {
        src: "https://images.unsplash.com/photo-1431540015161-0bf868a2d407?q=80&w=1600&auto=format&fit=crop",
        caption: "Egypt Trade Roadshow Opening Keynote",
      },
      {
        src: "https://images.unsplash.com/photo-1528605248644-14dd04022da1?q=80&w=1600&auto=format&fit=crop",
        caption: "Global Business Leaders Conference",
      },
      {
        src: "https://images.unsplash.com/photo-1573164713714-d95e436ab8d6?q=80&w=1600&auto=format&fit=crop",
        caption: "Bilateral Trade Delegates Meet",
      },
    ],
  },
  {
    id: "ip-02",
    country: "Malaysia",
    code: "MYS",
    flag: "🇲🇾",
    img: "https://images.unsplash.com/photo-1515187029135-18ee286d815b?q=80&w=900&auto=format&fit=crop",
    images: [
      {
        src: "https://images.unsplash.com/photo-1515187029135-18ee286d815b?q=80&w=1600&auto=format&fit=crop",
        caption: "Kuala Lumpur International Panel Briefing",
      },
      {
        src: "https://images.unsplash.com/photo-1551836022-d5d88e9218df?q=80&w=1600&auto=format&fit=crop",
        caption: "Malaysia Trade Board Representatives",
      },
      {
        src: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?q=80&w=1600&auto=format&fit=crop",
        caption: "Buyer-Seller Delegation Discussion",
      },
    ],
  },
  {
    id: "ip-03",
    country: "Qatar",
    code: "QAT",
    flag: "🇶🇦",
    img: "https://images.unsplash.com/photo-1560439514-4e9645039924?q=80&w=900&auto=format&fit=crop",
    images: [
      {
        src: "https://images.unsplash.com/photo-1560439514-4e9645039924?q=80&w=1600&auto=format&fit=crop",
        caption: "Doha Infrastructure Investment Summit",
      },
      {
        src: "https://images.unsplash.com/photo-1577495508048-b635879837f1?q=80&w=1600&auto=format&fit=crop",
        caption: "Qatar Chamber of Commerce Presentation",
      },
      {
        src: "https://images.unsplash.com/photo-1511578314322-379afb476865?q=80&w=1600&auto=format&fit=crop",
        caption: "Keynote Address at Riyadh Trade Summit",
      },
      {
        src: "https://images.unsplash.com/photo-1505373877841-8d25f7d46678?q=80&w=1600&auto=format&fit=crop",
        caption: "Delegates & Trade Investors Meeting",
      },
    ],
  },
  {
    id: "ip-04",
    country: "UAE",
    code: "UAE",
    flag: "🇦🇪",
    img: "https://images.unsplash.com/photo-1528605248644-14dd04022da1?q=80&w=900&auto=format&fit=crop",
    images: [
      {
        src: "https://images.unsplash.com/photo-1528605248644-14dd04022da1?q=80&w=1600&auto=format&fit=crop",
        caption: "Middle East Trade Agreement Signing",
      },
      {
        src: "https://images.unsplash.com/photo-1573164713714-d95e436ab8d6?q=80&w=1600&auto=format&fit=crop",
        caption: "Dubai Promotion Executive Panel",
      },
      {
        src: "https://images.unsplash.com/photo-1515187029135-18ee286d815b?q=80&w=1600&auto=format&fit=crop",
        caption: "UAE & Overseas Delegates Dialogue",
      },
    ],
  },
  {
    id: "ip-05",
    country: "Saudi Arabia",
    code: "KSA",
    flag: "🇸🇦",
    img: "https://images.unsplash.com/photo-1511578314322-379afb476865?q=80&w=900&auto=format&fit=crop",
    images: [
      {
        src: "https://images.unsplash.com/photo-1511578314322-379afb476865?q=80&w=1600&auto=format&fit=crop",
        caption: "Keynote Address at Riyadh Trade Summit",
      },
      {
        src: "https://images.unsplash.com/photo-1431540015161-0bf868a2d407?q=80&w=1600&auto=format&fit=crop",
        caption: "Saudi & Indian Trade Delegation Leaders",
      },
      {
        src: "https://images.unsplash.com/photo-1560179707-f14e90ef3623?q=80&w=1600&auto=format&fit=crop",
        caption: "Strategic Industrial Roadshow Assembly",
      },
    ],
  },
  {
    id: "ip-06",
    country: "South Korea",
    code: "KOR",
    flag: "🇰🇷",
    img: "https://images.unsplash.com/photo-1517430816045-df4b7de11d1d?q=80&w=900&auto=format&fit=crop",
    images: [
      {
        src: "https://images.unsplash.com/photo-1517430816045-df4b7de11d1d?q=80&w=1600&auto=format&fit=crop",
        caption: "Seoul Overseas Promotion Opening Keynote",
      },
      {
        src: "https://images.unsplash.com/photo-1573164713714-d95e436ab8d6?q=80&w=1600&auto=format&fit=crop",
        caption: "Korea-India Bilateral Tech Exchange Panel",
      },
      {
        src: "https://images.unsplash.com/photo-1517048676732-d65bc937f952?q=80&w=1600&auto=format&fit=crop",
        caption: "Closing Delegates Group Interaction",
      },
    ],
  },
];

/* Reveal-on-scroll photo tile: starts desaturated & soft, "develops"
   into full colour + sharpness once it enters the viewport. */
function PhotoTile({ item, index, onOpen }) {
  const ref = useRef(null);
  const isDeveloped = useInView(ref, { once: true, amount: 0.25 });

  const tilt = index % 2 === 0 ? "-1.1deg" : "1.3deg";

  return (
    <figure
      ref={ref}
      className={`ipm-tile${isDeveloped ? " is-developed" : ""}`}
      style={{ "--ipm-tilt": tilt, "--ipm-delay": `${(index % 6) * 0.08}s` }}
      onClick={() => onOpen(index)}
      role="button"
      tabIndex={0}
      aria-label={`Open photo ${index + 1}: ${item.caption || ""}`}
      onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && onOpen(index)}
    >
      <span className="ipm-tile__frame">
        <span className="ipm-tile__sheen" aria-hidden="true" />
        <img
          src={item.src}
          alt={item.caption || "Event photo"}
          loading="lazy"
        />
      </span>
      {item.caption && (
        <figcaption className="ipm-tile__cap">{item.caption}</figcaption>
      )}
    </figure>
  );
}

export default function InternationalPromotionsMedia() {
  const { id } = useParams();

  const [lightboxIndex, setLightboxIndex] = useState(-1);

  // Scroll to the top whenever a different album is opened.
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "instant" in window ? "instant" : "auto",
    });
  }, [id]);

  if (!id) {
    return <GalleryInternationalPromotions />;
  }

  const album = INTERNATIONAL.find((c) => c.id === id) || INTERNATIONAL[0];

  const images =
    album && album.images && album.images.length
      ? album.images
      : [{ src: album ? album.img : "" }];
  const slides = images.map((item) => ({
    src: item.src,
    title: item.caption,
    description: album ? album.country : "",
  }));

  return (
    <section className="ipm">
      <div className="ipm__lightleak" aria-hidden="true" />
      <div className="ipm__grain" aria-hidden="true" />

      <header className="ipm__hero">
        <div className="clean-breadcrumb-wrapper">
          <nav className="about-style-breadcrumb" aria-label="Breadcrumb">
            <Link to="/" className="bc-home-link">
              HOME
            </Link>
            <span className="bc-slash">/</span>
            <span className="bc-active-page">INTERNATIONAL PROMOTIONS</span>
          </nav>
        </div>
        <h1 className="ipm__title">International Promotions</h1>
      </header>

      <div className="ipm__trail">
        <Link to="/gallery#internationalpromotions" className="ipm__trail-link">
          Main Album
        </Link>
        <span className="ipm__trail-sep">
          <BsChevronDoubleRight />
        </span>
        <span className="ipm__trail-current">{album.country}</span>
      </div>

      {/* <div className="ipm__meta">
        <span className="ipm__meta-dot" />
        {album.country} &middot; {images.length} photo
        {images.length !== 1 ? "s" : ""}
      </div> */}

      <div className="ipm__grid">
        {images.map((item, i) => (
          <PhotoTile key={i} item={item} index={i} onOpen={setLightboxIndex} />
        ))}
      </div>

      <Lightbox
        open={lightboxIndex >= 0}
        index={lightboxIndex}
        close={() => setLightboxIndex(-1)}
        slides={slides}
        plugins={[Zoom]}
        thumbnails={{ position: "bottom", border: 0, gap: 8, padding: 0 }}
        counter={{ container: { style: { top: "unset", bottom: 0 } } }}
        animation={{ swipe: 280 }}
      />
    </section>
  );
}
